import React, { useState } from 'react';
import { Container, Form, Button, Alert, Row, Col } from 'react-bootstrap';
import { useMediaQuery } from 'react-responsive';
import { getFornitoreImportColumns, importFornitori } from '../services/api';

const FornitoriImport = () => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState(''); // 'success' or 'danger'
    const [csvColumns, setCsvColumns] = useState([]);
    const [columnMapping, setColumnMapping] = useState({});
    
    const isMobile = useMediaQuery({ maxWidth: 991 });

    const fornitoreSchemaFields = [
        { key: 'denominazione', label: 'Denominazione', required: true },
        { key: 'email', label: 'Email' },
        { key: 'partita_iva', label: 'Partita IVA' },
        { key: 'codice_fiscale', label: 'Codice Fiscale' },
        { key: 'indirizzo', label: 'Indirizzo' },
        { key: 'cap', label: 'CAP' },
        { key: 'citta', label: 'Città' },
        { key: 'provincia', label: 'Provincia' },
        { key: 'nazione', label: 'Nazione' },
        { key: 'codice_destinatario', label: 'Codice Destinatario' },
        { key: 'telefono', label: 'Telefono' },
        { key: 'cellulare', label: 'Cellulare' },
        { key: 'pec', label: 'PEC' },
        { key: 'luogo_nascita', label: 'Luogo di Nascita' },
        { key: 'data_nascita', label: 'Data di Nascita' },
    ];

    const handleFileChange = async (event) => {
        const file = event.target.files[0];
        setSelectedFile(file);
        setMessage('');
        setCsvColumns([]);
        setColumnMapping({});

        if (file) {
            try {
                const response = await getFornitoreImportColumns(file);
                const columns = response.data;
                setCsvColumns(columns);

                const initialMapping = {};
                fornitoreSchemaFields.forEach(field => {
                    const matchedColumn = columns.find(col => col.toLowerCase() === field.label.toLowerCase() || col.toLowerCase() === field.key.toLowerCase());
                    if (matchedColumn) {
                        initialMapping[field.key] = matchedColumn;
                    }
                });
                setColumnMapping(initialMapping);

            } catch (error) {
                console.error('Errore durante il recupero delle colonne:', error);
                setMessage(error.response?.data?.detail || 'Errore durante il recupero delle colonne del file.');
                setMessageType('danger');
            }
        }
    };

    const handleMappingChange = (schemaField, csvColumn) => {
        setColumnMapping(prev => ({
            ...prev,
            [schemaField]: csvColumn === '' ? null : csvColumn,
        }));
    };

    const handleUpload = async () => {
        if (!selectedFile) {
            setMessage('Seleziona un file CSV/Excel da importare.');
            setMessageType('danger');
            return;
        }

        const requiredFieldsMapped = fornitoreSchemaFields.filter(field => field.required).every(field => columnMapping[field.key]);
        if (!requiredFieldsMapped) {
            setMessage('Assicurati di mappare tutti i campi obbligatori (es. Denominazione).');
            setMessageType('danger');
            return;
        }

        try {
            const response = await importFornitori(selectedFile, columnMapping);
            setMessage(response.data.message);
            setMessageType('success');
            setSelectedFile(null);
            setCsvColumns([]);
            setColumnMapping({});
        } catch (error) {
            console.error('Errore durante l\'importazione del file:', error);
            setMessage(error.response?.data?.detail || 'Errore durante l\'importazione del file.');
            setMessageType('danger');
        }
    };

    return (
        <Container>
            <h2>Importa Fornitori da CSV/Excel</h2>
            {message && <Alert variant={messageType}>{message}</Alert>}
            <Form>
                <Form.Group controlId="formFile" className="mb-3">
                    <Form.Label>Seleziona un file CSV o Excel</Form.Label>
                    <Form.Control type="file" accept=".csv, .xls, .xlsx" onChange={handleFileChange} />
                </Form.Group>

                {csvColumns.length > 0 && (
                    <div className="mb-3">
                        <h3>Mappa Colonne</h3>
                        <p>Associa le colonne del tuo file ai campi del database.</p>
                        {fornitoreSchemaFields.map(field => {
                            const selectedCsvColumn = columnMapping[field.key];
                            const mappedColumns = Object.values(columnMapping).filter(val => val !== null);
                            const availableCsvColumns = csvColumns.filter(col => 
                                !mappedColumns.includes(col) || col === selectedCsvColumn
                            );

                            return (
                                <Row key={field.key} className="mb-2 align-items-center">
                                    <Col sm={4} className="text-sm-end">
                                        <Form.Label className="mb-0">{field.label} {field.required && <span className="text-danger">*</span>}</Form.Label>
                                    </Col>
                                    <Col sm={8}>
                                        <Form.Select
                                            value={selectedCsvColumn || ''}
                                            onChange={(e) => handleMappingChange(field.key, e.target.value)}
                                        >
                                            <option value="">Ignora</option>
                                            {availableCsvColumns.map(col => (
                                                <option key={col} value={col}>{col}</option>
                                            ))}
                                        </Form.Select>
                                    </Col>
                                </Row>
                            );
                        })}
                    </div>
                )}

                <Button variant="primary" onClick={handleUpload} disabled={!selectedFile || csvColumns.length === 0}>
                    Importa
                </Button>
            </Form>
        </Container>
    );
};

export default FornitoriImport;
